import Navigator from "../../../../publicComponent/h5/Navigator";
import FooterMall9 from "../../../../publicComponent/Footer/FooterMall9";
import {useEffect, useState} from "react";
import {getSrc, mediaMatch} from "../../../../utils";
import {useLocation, useNavigate} from "react-router";
import {useGetUserPointInfo} from "../../../../api/UdianPointHistory";
import {useAsyncEffect} from "ahooks";
import cookies from "../../../../utils/cookies";
import {useNavigateTo} from "../../../../hooks/useNavigateTo";
import {useTranslation} from "react-i18next";
import Avatar from "../../../../publicComponent/Avatar";

function InfoCard({ info }) {
  const { t } = useTranslation();
  const userInfo = cookies.getUserInfo() || {};
  
  return (
    <div className="mt-[10px]">
      <div className="flex items-center py-[15px]">
        <Avatar src={userInfo.headImg || userInfo.headPicture}/>
        <div className="flex-1 ml-[15px]">
          <p className="text-[#333] text-[16px] font-bold mb-[2px]">
            {userInfo.userName || '商城用户'}
          </p>
          <p className="text-[#333]">No: {userInfo.vipCardNo}</p>
        </div>
      </div>
    </div>
  );
}

const menus = [
  {
    name: '我的订单',
    path: '/orderList',
    icon: 'order'
  },
  // {
  //   name: '提货码',
  //   path: '',
  //   icon: 'qrcode',
  // },
  {
    name: '我的预约',
    path: '/myBooking',
    icon: 'booking',
  },
  {
    name: '收货地址',
    path: '/shippingAddress',
    icon: 'location'
  },
  {
    name: '我的优惠券',
    path: '/myCoupon',
    icon: 'coupon'
  },
  {
    name: '我的积分',
    path: '/myIntegral',
    icon: 'coupon'
  },
  // {
  //   name: '联系我们',
  //   path: '',
  //   icon: 'mobile'
  // },
];

export default function My() {
  const { getPointInfo } = useGetUserPointInfo();
  const [pointInfo, setPointInfo] = useState({});
  const { t } = useTranslation();
  const location = useLocation();
  const navigateTo = useNavigateTo();
  
  useAsyncEffect(async () => {
    if (!mediaMatch.isMdmax) {
      navigateTo('/', { replace: true });
    } else {
      
      if (!cookies.getToken()) {
        navigateTo(`/login?redirect=${location.pathname}`, { replace: true });
      } else {
        let { data } = await getPointInfo();
        
        if (data) {
          setPointInfo(data);
        }
      }
    }
  }, []);
  
  return (
    <div className="mdmax:pb-[60px]">
      <Navigator title="我的"/>
      <Navigator.container className="container-center mobile">
        <InfoCard info={pointInfo}/>
        <div className="px-[15px] divide-y divide-[#ddd] flex flex-col mt-[10px]">
          {
            menus.map((item, i) => (
              <div className="flex justify-between py-[18px]"
                   onClick={() => navigateTo(item.path)}
                   key={i}>
                <div className="flex items-center">
                  <i className={`mr-[10px]`}>
                    <img className="w-[18px] h-18" src={(new URL(`./imgs/icon-${item.icon}.png`, import.meta.url).href)}/>
                  </i>
                  <span className="text-[14px]">{t(item.name)}</span>
                </div>
                <i className="iconfont icon-right text-[#999]"></i>
              </div>
            ))
          }
        </div>
      </Navigator.container>
      <FooterMall9/>
    </div>
  );
}

